<dashboardnav>
  <div class="reference_body">
    <main class="reference_main">
      <div class="pink_box"></div>
      <div class="green_box"></div>
  <div [ngSwitch]="task">
    <ng-template ngSwitchCase = "list">
      <!-- <pre>{{isLoadingProjectManagement$ | async | json}}</pre> -->
      <mrsoftapps-project-report
      [countries]="country$ | async"
      [states]="state$ | async"
      [lgas]="lga$ | async"
      [projectTypes]="projectType$ | async"
      [projectCategories]="projectCategory$ | async"
      [oilBlocks]="oilBlock$ | async"
      [oilFields]="oilField$ | async"
      [communities]="community$ | async"
      [clusters]="cluster$ | async"
      [clusterCommunity]="clusterCommunity$ | async"
      [projectManagements]="projectManagement$ | async"
      [gmous]="gmou$ | async"
      [currencies]="currency$ |async"
      [documentCategory]="documentCategory$ | async"
      [documentSubCategory]="documentSubCategory$ | async"
      (changeEmit)="onTriggerEmit($event)"
      (onActivityEmit)="onEmitActivity($event)"
      (deleteEvent)="onDeleteEVent($event)"
      (taskEmit)="taskEvent($event)"
      *ngIf="
      !(isLoadingProjectManagement$ | async) &&
      !(isLoadingCountry$ | async) &&
      !(isLoadingState$ | async) &&
      !(isLoadingLga$ | async) &&
      !(isLoadingCommunity$ | async) &&
      !(isLoadingProjectType$ | async) &&
      !(isLoadingCluster$ | async) &&
      !(isLoadingClusterCommunity$ | async) &&
      !(isLoadingProjectCategory$ | async) &&
      !(isLoadingOilBlock$ | async) &&
      !(isLoadingOilField$ | async) &&
      !(isLoadingDocumentCategory$ | async) &&
      !(isLoadingDocumentSubCategory$ | async) &&
      !(isLoadingGmou$ | async) &&
      !(isLoadingCurrency$ | async)
"
      >


      </mrsoftapps-project-report>

    </ng-template>

  </div>



<mrsoftapps-epims-reference-spinner
*ngIf="
(isLoadingProjectManagement$ | async) ||
(isLoadingCountry$ | async) ||
(isLoadingState$ | async) ||
(isLoadingLga$ | async) ||
(isLoadingCommunity$ | async) ||
(isLoadingProjectType$ | async) ||
(isLoadingCluster$ | async) ||
(isLoadingClusterCommunity$ | async) ||
(isLoadingProjectCategory$ | async) ||
(isLoadingOilBlock$ | async) ||
(isLoadingOilField$ | async) ||
(isLoadingDocumentCategory$ | async) ||
(isLoadingDocumentSubCategory$ | async) ||
(isLoadingGmou$ | async) ||
(isLoadingCurrency$ | async)
"


></mrsoftapps-epims-reference-spinner>
</main>
</div>
</dashboardnav>
